import SubMenuCibra from "./SubMenuCibra";

export default SubMenuCibra;
